/**
 * Beneficiary communities — server state (D19).
 *
 * Configuration-like: it changes when Parinaam edits the list in NocoDB, which
 * is rare, so it is cached like reference data.
 */

import { useQuery } from '@tanstack/react-query';
import { listCommunities } from '../services/api/communities';

const STALE_TIME_MS = 5 * 60 * 1000;

export function useCommunities() {
  return useQuery({
    queryKey: ['communities'],
    queryFn: listCommunities,
    staleTime: STALE_TIME_MS,
  });
}
